import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        course: '=',
        userIds: '=',
        showNavigationError: '=',
        showAddButton: '=',
        classifiers: '<',
        form: '=',
        files: '='
    },
    template: `
        <div class="form">
            <div class="heading01">
                <p class="desc">{{ 'historic.occurrence.targets.notification' | translate }}</p>
                <ul class="actions01">
                    <li class="primary">
                        <a class="btn ico-filter" ng-click="vm.toggleFilter = !vm.toggleFilter">{{ 'targetedFilter.Filter' | translate }}</a>
                    </li>
                </ul>
            </div>
            <modals-courses-historic-occurrence-employee-targets-filter
                course="vm.course"
                toggle-filter="vm.toggleFilter"
                classifiers="vm.classifiers"
                list="vm.list"
                default-filter="vm.defaultFilter"
            />
            <modals-courses-historic-occurrence-employee-table
                list="vm.list"
                user-ids="vm.userIds"
                show-navigation-error="vm.showNavigationError"
                show-add-button="vm.showAddButton"
                form="vm.form"
                course="vm.course"
                files="vm.files"
            />
        </div>
    `
})
export default class {
    constructor (DATATABLES, MomentService, SiteService, UserResource, ListFactory) {
        this.DATATABLES = DATATABLES;
        this.MomentService = MomentService;
        this.SiteService = SiteService;

        this.list = ListFactory.createWithPagination(UserResource.getUsers.bind(UserResource));
        this.list.pagination.perPage = 25;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/historicOccurrence/employee/targets/index.js